/** English defaults for /article-submission */

export const articleSubmissionEn = {
  pageTitle: 'Article Submission',
  journalCard: {
    title: 'Journal Information',
    labelTitle: 'Title:',
    valueTitle: 'Advances in Applied Engineering Sciences (AdvAES)',
    labelLanguage: 'Language:',
    valueLanguage: 'English',
    labelLength: 'Article Length:',
    valueLength: '6-10 pages',
    labelFee: 'Publication Fee:',
    valueFee: 'free',
    labelConfFee: 'Conference Participation and Publication Fee:',
    valueConfFee: 'free',
  },
  templatesCard: {
    title: 'Article Templates',
    step1Before: 'Prepare your article according to the ',
    step1LinkText: 'journal requirements and template',
    step1After: '.',
    guidelinesPath: '/guidelines-for-authors',
    step2Before: 'Register or log in to the EasyChair system. Follow link to ',
    step2LinkText: 'register',
    step2After: '',
    easyChairUrl: 'https://easychair.org/registration',
    step3: 'Upload your article in .docx or pdf format.',
    step4: 'Fill in the required author and article information.',
    step5: 'Submit your article for review.',
  },
};
